'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _auth = require('redux/modules/auth');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Please keep routes in alphabetical order
 */
exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var _store$getState = store.getState(),
          auth = _store$getState.auth;

      if (!auth.token) {
        replace('/login');
      }
      cb();
    }

    if (!(0, _auth.isLoaded)(store.getState())) {
      replace('/login');
    } else {
      checkAuth();
    }

    cb();
  };

  return _react2.default.createElement(
    _reactRouter.Route,
    { component: _containers.Base },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/', component: _containers.App },
      _react2.default.createElement(_reactRouter.IndexRoute, {
        components: { content: _containers.GenericSettings, subHeader: _containers.GenericSettingsSubHeader }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/configuration',
        components: { content: _containers.Configuration, subHeader: _containers.ConfigurationSubHeader }
      }),
      _react2.default.createElement(_reactRouter.Route, {
        path: '/generic-settings',
        components: { content: _containers.GenericSettings, subHeader: _containers.GenericSettingsSubHeader }
      }),
      _react2.default.createElement(
        _reactRouter.Route,
        {
          path: 'template-application'
        },
        _react2.default.createElement(_reactRouter.IndexRoute, { components: { content: _containers.TemplateApplication, subHeader: _containers.TemplateApplicationSubHeader } }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'template-configuration',
          components: { content: _containers.TemplateConfiguration, subHeader: _containers.TemplateConfigurationSubHeader }
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: 'template-configuration/:template',
          components: { content: _containers.TemplateConfiguration, subHeader: _containers.TemplateConfigurationSubHeader }
        })
      )
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '/email', component: _containers.Email }),
    _react2.default.createElement(_reactRouter.Route, { path: '/email/:template', component: _containers.Email }),
    _react2.default.createElement(_reactRouter.Route, { path: '/email/:template/:token', component: _containers.Email }),
    _react2.default.createElement(_reactRouter.Route, {
      path: '/login',
      component: _containers.LoginScreen
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '*', component: _containers.App, status: 404 },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.NotFound })
    )
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.jsx
// module id = 1667
// module chunks = 0